// Single source of truth for QuoteHaul Pro's displayed pricing — referenced
// by both UpgradeModal.jsx (in-app upgrade/trial-gate flow) and the public
// landing page, so the two can never independently drift on the numbers
// shown to a customer. These are display figures only (monthly-equivalent);
// the real charge amount always comes from Stripe's actual Price objects at
// checkout time (see functions/checkout.js's PRICE_LOOKUP_KEYS).
export const BASE_MONTHLY = 59;
export const BASE_ANNUAL = 49;
export const SEAT_MONTHLY = 19;
export const SEAT_ANNUAL = 15;
export const ANNUAL_SAVINGS_LABEL = 'Save 20%';
export const TRIAL_DAYS = 14;
